// src/App.js
import React, { useEffect } from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Import all section components
import Hero from './components/sections/Hero';
import FastExecution from './components/sections/FastExecution';
import Features from './components/sections/Features';
import Rewards from './components/sections/Rewards';
import Markets from './components/sections/Markets';
import CTA from './components/sections/CTA';

function App() {
  // Intersection Observer for Scroll Animations
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          // Optional: Stop observing once visible
          observer.unobserve(entry.target); 
        }
      });
    }, { threshold: 0.1 });

    // Target all elements that should animate on scroll
    document.querySelectorAll('.fade-in, .slide-in-left, .slide-in-right, .scale-in').forEach(element => {
      observer.observe(element);
    });

    // Cleanup function
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <FastExecution />
        <Features />
        <Rewards />
        <Markets />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;